import React from "react";
import {useSelector} from "react-redux";

export default function ({order}) {
  const user = useSelector(state => state.user);
  const isAdminType = user?.isAdminType;

  return (
    <div className="col-xxl-12 pt-5">
      <div className="card card-flush py-4 flex-row-fluid">
        <div className="card-header">
          <div className="card-title">
            <h2>Summary</h2>
          </div>
        </div>
        <div className="card-body pt-0">
          <div className="table-responsive">
            <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
              <tbody className="fw-bold text-gray-600">
              <tr>
                <td className="text-muted">
                  Subtotal
                </td>
                <td className="text-end">{order.price}</td>
              </tr>
              <tr>
                <td className="text-muted">
                  Delivery price
                </td>
                <td className="text-end">{order.delivery_price}</td>
              </tr>
              {isAdminType && (
                <tr>
                  <td className="text-muted">
                    Discount amount
                  </td>
                  <td className="text-end">{order.discount_amount}</td>
                </tr>
              )}
              <tr>
                <td className="fs-3 text-dark">
                  Grand Total
                </td>
                <td
                  className="text-dark fs-3 fw-boldest text-end">{isAdminType ? order.total_discounted_price : order.total_price}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}